import { Component, Input } from '@angular/core'
import { Rental } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-rental-group-label',
  templateUrl: './rental-group-label.component.html',
  styles: [
    `
      :host {
        display: block;
        font-weight: 600;
      }
    `,
  ],
})
export class RentalGroupLabelComponent {
  @Input() height: number
  @Input() rental: Rental
  @Input() label: string
  @Input() labelClass: string
}
